"use client";

import { useCallback } from "react";
import { cn } from "@workspace/ui/lib/utils";
import { TakeQuizChip } from "./take-quiz-chip";
import { useQuizState } from "../hooks/use-quiz-state";
import { useQuizTouchpointImpressionVisible } from "../hooks/use-quiz-touchpoint-impression";

export function QuizSideChip({visible}: {visible: boolean}) {
  const { handleQuizTap, ctaLabel, quizState } = useQuizState();

  useQuizTouchpointImpressionVisible("side_chip", visible);

  const handleClick = useCallback(() => {
    handleQuizTap("side_chip");
  }, [handleQuizTap]);

  return (
    <button
      type="button"
      id="quiz-side-chip-cta"
      data-testid="quiz-side-chip-cta"
      aria-label={ctaLabel}
      onClick={handleClick}
      className={cn(
        "fixed right-0 bottom-[50%] translate-y-[50%] z-[49] cursor-pointer p-0 border-none bg-transparent",
        "transition-transform duration-300 ease-in-out",
        visible ? "translate-x-0" : "translate-x-full",
      )}
    >
      <TakeQuizChip label={!quizState.status? "Get Sample Hormone Chart" :  ctaLabel} />
    </button>
  );
}
